import Container from '@mui/material/Container';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { BulkShifts } from '../../features/schedules/Schedule/components';

const ScheduleBulkShiftsPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.BULK_SHIFTS}>
    <Container
      sx={{
        px: {
          xs: 0, lg: 2, md: 2, sm: 2,
        },
      }}
      maxWidth={false}
    >
      <BulkShifts />
    </Container>
  </PageHelmet>
);

export default ScheduleBulkShiftsPage;
